/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Orders_Confirm_Local_Pickup_SwitchInputs */

const en_orders_confirm_local_pickup_switch = /** @type {(inputs: Orders_Confirm_Local_Pickup_SwitchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Confirm Local Pickup Switch`)
};

const es_orders_confirm_local_pickup_switch = /** @type {(inputs: Orders_Confirm_Local_Pickup_SwitchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Confirmar cambio a recogida local`)
};

/**
* | output |
* | --- |
* | "Confirm Local Pickup Switch" |
*
* @param {Orders_Confirm_Local_Pickup_SwitchInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const orders_confirm_local_pickup_switch = /** @type {((inputs?: Orders_Confirm_Local_Pickup_SwitchInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Orders_Confirm_Local_Pickup_SwitchInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_orders_confirm_local_pickup_switch(inputs)
	return es_orders_confirm_local_pickup_switch(inputs)
});